import React, { useState, useContext, useEffect, useReducer } from 'react';
import { Table, Page } from '../../components';
import { default as GoodsNew } from './new';
import { default as SpecList } from './specList';
import { default as GoodsImport } from './goodsImport';
import { default as GoodsImportAll } from './goodsImportAll';
import './style';
import {
  getList, getListCount,
  insert,
  update,
  checkCanDelete,
  deleteById,
  insertSpec,
  insertSpecs,
  updateSpecs,
  downloadTemplate,
  downloadData,
  downloadDataAll
} from '../../services/Goods';

import { getGoodsListByDatetime as getBuyerGoodsList, getListEnabled as getBuyerList } from '../../services/Buyer';
import { getGoodsListByDatetime as getSupplierGoodsList, getListEnabled as getSupplierList } from '../../services/Supplier';
import {
  getList as getViewList, getListCount as getViewListCount,
} from '../../services/View';
import { getDatetime } from '../../services/Login';

import {
  message,
  Modal,
  Button,
  Menu,
  Select
} from 'antd';
import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  ImportOutlined,
  ExportOutlined,
  DownloadOutlined,
  OrderedListOutlined,
  TableOutlined,
  UploadOutlined
} from '@ant-design/icons';

import { MasterContext } from '../../App';
export default React.forwardRef((props, ref) => {
  const { currentUser, authorities, goods_category } = useContext(MasterContext);
  const [isShowNew, setShowNew] = useState(false);
  const [isShowEdit, setShowEdit] = useState(false);
  const [isShowSpec, setShowSpec] = useState(false);
  const [isShowPart, setShowPart] = useState(false);
  const [isLoadding, setLoadding] = useState(false);
  const [isShowImport, setShowImport] = useState(false);
  const [keyword, setKeyword] = useState(undefined);
  const [clickedIndex, setClickedIndex] = useState(undefined);
  const [view, setView] = useState({ type: 0, name: '', key: undefined });

  const [isShowImportAll, setShowImportAll] = useState(false);

  const initialState = {
    buyers: [],
    buyer_goods: [],
    suppliers: [],
    supplier_goods: [],
    total_rows: 0,
    rows: [],
    sort: { order: 'desc', sort: 'updated' },
    pagination: { limit: 10, offset: 0 },
    views: []
  };

  const setPage = (page, pageSize) => {
    dispatch({ type: 'pagination', data: { limit: pageSize, offset: (page - 1) * pageSize } });
  }
  const setSelected = (selected) => {
    dispatch({ type: 'selected', data: selected });
  }
  function reducer(state, action) {
    switch (action.type) {
      case 'buyers':
        return Object.assign({}, state, { buyers: action.data });
      case 'buyer_goods':
        return Object.assign({}, state, { buyer_goods: action.data });
      case 'suppliers':
        return Object.assign({}, state, { suppliers: action.data });
      case 'supplier_goods':
        return Object.assign({}, state, { supplier_goods: action.data });
      case 'list':
        return Object.assign({}, state, { rows: action.data });
      case 'total_rows':
        return Object.assign({}, state, { total_rows: action.data });
      case 'pagination':
        return Object.assign({}, state, { pagination: action.data });
      case 'selected':
        const rows = state.rows;
        for (let i = 0; i < rows.length; i++) {
          if ((action.data || []).indexOf(i) > -1) {
            rows[i].selected = true;
          } else {
            rows[i].selected = false;
          }
        }
        return Object.assign({}, state, { rows: rows });
      case 'new':
        return { total: state.total + 1 };
      case 'edit':
        return { total: state.total };
      case 'delete':
        return { total: state.total - 1 };
      case 'goods_category':
        return Object.assign({}, state, { goods_category: action.data });
      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    setLoadding(true);
    if (view.type === 0) {
      var p1 = new Promise((resolve, reject) => {
        getListCount(keyword).then(data => {
          dispatch({ type: 'total_rows', data: data });
          resolve(true);
        });
      });

      var p2 = new Promise((resolve, reject) => {
        getList(state.pagination, undefined, keyword).then(data => {
          dispatch({ type: 'list', data: data });
          resolve(true);
        });
      });

      var p3 = new Promise((resolve, reject) => {
        getBuyerList().then(data => {
          dispatch({ type: 'buyers', data: data });
          resolve(true);
        });
      });

      var p4 = new Promise((resolve, reject) => {
        getSupplierList().then(data => {
          dispatch({ type: 'suppliers', data: data });
          resolve(true);
        });
      });

      Promise.all([p1, p2, p3, p4]).then(values => {
        setLoadding(false);
      });
    } else {
      var p1 = new Promise((resolve, reject) => {
        getViewListCount('fv_page_goods_spec_list', keyword).then(data => {
          dispatch({ type: 'total_rows', data: data });
          resolve(true);
        });
      });

      var p2 = new Promise((resolve, reject) => {
        getViewList('fv_page_goods_spec_list', state.pagination, keyword).then(data => {
          dispatch({ type: 'list', data: data });
          resolve(true);
        });
      });
      var p3 = new Promise((resolve, reject) => {
        if (view.type === 2) {
          getDatetime().then(data => {
            getBuyerGoodsList(view.key, data).then(data => {
              dispatch({ type: 'buyer_goods', data: data });
              resolve(true);
            });
          });
        } else if (view.type === 3) {
          getDatetime().then(data => {
            getSupplierGoodsList(view.key, data).then(data => {
              dispatch({ type: 'supplier_goods', data: data });
              resolve(true);
            });
          });
        } else {
          resolve(true);
        }
      });
      Promise.all([p1, p2, p3]).then(values => {
        setLoadding(false);
      });
    }

  }, [state.pagination, keyword, view]);

  const afterClose = (e) => {

  }

  const reload = () => {
    if (view.type === 0) {
      var p1 = new Promise((resolve, reject) => {
        getListCount().then(data => {
          dispatch({ type: 'total_rows', data: data });
          resolve(true);
        });
      });

      var p2 = new Promise((resolve, reject) => {
        getList(state.pagination).then(data => {
          dispatch({ type: 'list', data: data });
          resolve(true);
        });
      });

      return Promise.all([p1, p2]).then(values => {
        //setLoadding(false);
      });
    } else {
      var p1 = new Promise((resolve, reject) => {
        getViewListCount('fv_page_goods_spec_list').then(data => {
          dispatch({ type: 'total_rows', data: data });
          resolve(true);
        });
      });

      var p2 = new Promise((resolve, reject) => {
        getViewList('fv_page_goods_spec_list', state.pagination).then(data => {
          dispatch({ type: 'list', data: data });
          resolve(true);
        });
      });
      return Promise.all([p1, p2]).then(values => {
        //setLoadding(false);
      });
    }
  }

  const downloadGoodsTemplate = () => {
    const key = 'download_all';
    message.loading({ content: '正在下载产品列表模板...', key, duration: 20 });
    downloadTemplate("goods_template").then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = "goods_template_" + new Date().getTime();
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `产品列表模板生成成功`, key, duration: 2 });
      }
    });
  }
  const downloadGoods = () => {
    const key = 'download_all';
    message.loading({ content: '正在生成产品列表...', key, duration: 20 });
    downloadData().then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = "goods_data_" + new Date().getTime();
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `产品列表生成成功`, key, duration: 2 });
      }
    });
  }

  const importGoodsAll = () => {
    setShowImportAll(true)
  }

  const downloadGoodsAll = () => {
    const key = 'download_all';
    message.loading({ content: '正在生成产品通览表...', key, duration: 20 });
    downloadDataAll().then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = "all_goods_data_" + new Date().getTime();
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `产品通览表生成成功`, key, duration: 2 });
      }
    });
  }

  const onNewCallback = async (goods) => {
    try {
      const key = 'create_goods';
      console.log('onNewCallback:', goods);
      message.loading({ content: '正在新建产品...', key });
      insert(goods).then(() => {
        reload().then(() => {
          setShowNew(false);
          message.success({ content: `新建产品成功 [#${goods.name_en}]`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onDeleteCallback = async (value) => {
    try {
      const key = 'delete_goods';
      console.log('onDeleteCallback:', value);

      const arr = [];
      let datas = [];
      value.forEach(x=> {
        arr.push(new Promise((resolve, reject)=> {
          checkCanDelete(x).then(data=> {
            data.forEach(y=> {
              if (!datas.find(z=>z.po_code === y.po_code)) {
                datas.push(y);
              }
            })
            resolve(data);
          })
        }))
      });
      Promise.all(arr).then(() => {
        if (datas.length > 0 ) {
          Modal.error({
            title: '删除错误',
            content: <span>
              <strong>部分产品已被下列订单使用，不能删除。</strong><br/>
                {
                  datas.map(x=> {
                    return <div><strong>{x.po_code}</strong> - {x.no}</div>
                  })
                }
            </span>
          });
          return;
        }
        message.loading({ content: `正在删除产品 ...`, key });
        deleteById(value.join(',')).then((data) => {
          reload().then(() => {
            message.success({ content: `删除产品成功 `, key, duration: 2 });
          })
        })
      })
      
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSaveCallback = async (goods) => {
    try {
      const key = 'update_goods';
      message.loading({ content: '正在修改产品...', key });
      console.log('onSaveCallback:', goods);
      update(goods.id, goods).then(() => {
        reload().then(() => {
          setShowEdit(false);
          message.success({ content: `修改产品成功 [#${goods.name_en}]`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onClickId = (index) => {
    setClickedIndex(index);
    setShowEdit(true);
  }

  const onClickSpec = (index) => {
    setClickedIndex(index);
    setShowSpec(true);
  }
  const { rows, buyers, suppliers, buyer_goods, supplier_goods, total_rows } = state;

  let view_rows = [].concat(rows);
  if (view.type === 2) {
    buyer_goods.forEach(x => {
      const find = view_rows.find(y => y.goods_id === x.goods_id && y.goods_spec_id === x.goods_spec_id);
      if (find) {
        find.buyer_name = (buyers.find(z => z.id === parseInt(view.key)) || {}).name_en;
        find.pcs_per_carton = x.pcs_per_carton;
        find.carton_count_per_pallet = x.carton_count_per_pallet;
        find.price = x.price;
      }
    });
  }
  if (view.type === 3) {
    supplier_goods.forEach(x => {
      const find = view_rows.find(y => y.goods_id === x.goods_id && y.goods_spec_id === x.goods_spec_id);
      if (find) {
        find.supplier_name = (suppliers.find(z => z.id === parseInt(view.key)) || {}).name;
        find.price = x.price;
      }
    });
  }

  const showDeleteConfirm = () => {
    const deleted = rows.filter(x => x.selected);
    const names = [];
    const ids = [];
    deleted.map((item) => { names.push(<div>{item.name_cn}</div>); ids.push(item.id) })
    Modal.confirm({
      title: '确定删除当前项目吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{names}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDeleteCallback(ids)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onChangeView = (type, name, key) => {
    setPage(1, state.pagination.limit);
    setView({ type, name, key });
  }

  const newOptionMenu = (
    <Menu>
      <Menu.Item key="1" onClick={() => setShowImport(true)} icon={<ImportOutlined />}>
        <span style={{ padding: '0 1rem', color: 'blue' }}><Button size="small" type="link">从模板导入 (仅产品)</Button></span>
      </Menu.Item>
      <Menu.Item key="2" onClick={() => downloadGoods(true)} icon={<ExportOutlined />}>
        <span style={{ padding: '0 1rem', color: 'blue' }}><Button size="small" type="link">导出到Excel (仅产品)</Button></span>
      </Menu.Item>
      <Menu.Item key="3" onClick={() => downloadGoodsTemplate(true)} icon={<DownloadOutlined />}>
        <span style={{ padding: '0 1rem' }}>&nbsp;&nbsp;下载空白模板 (仅产品)</span>
      </Menu.Item>
      <Menu.Divider>
      </Menu.Divider>
      <Menu.Item key="4" onClick={() => downloadGoodsAll(true)} icon={<DownloadOutlined />}>
        <span style={{ padding: '0 1rem', color: 'blue' }}><Button size="small" type="link">下载产品通览表</Button></span>
      </Menu.Item>
      <Menu.Item key="5" onClick={() => importGoodsAll(true)} icon={<UploadOutlined />}>
        <span style={{ padding: '0 1rem', color: 'blue' }}><Button size="small" type="link">更新产品通览表</Button></span>
      </Menu.Item>
    </Menu>
  );

  const optionView = (
    <Menu mode="vertical">
      <Menu.Item key="0" onClick={() => onChangeView(0, '--默认视图--')} icon={<TableOutlined />}>
        <span style={{ padding: '0 1rem' }}>--默认视图--</span>
        {/* <div style={{ marginLeft: 'auto' }} /> */}
        {/* <Button type="link" icon={<EditOutlined />} size="small" />
        <Button danger type="link" icon={<DeleteOutlined />} size="small" /> */}
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="21" onClick={() => onChangeView(1, '产品一览视图')} icon={<OrderedListOutlined />}>
        <span style={{ padding: '0 1rem' }}>产品一览视图</span>
      </Menu.Item>


      <Menu.SubMenu onClick={(key) => onChangeView(2, '产品一览视图-客户', key.key)} key="buyer" icon={<OrderedListOutlined />} title={<span style={{ padding: '0 1rem' }}>产品一览视图-客户</span>}>
        {
          state.buyers.map(x => {
            return <Menu.Item key={x.id}><span style={{ padding: '0 1rem' }}>[{x.name_nick}]-{x.name_en}</span></Menu.Item>;
          })
        }
      </Menu.SubMenu>
      <Menu.SubMenu onClick={(key) => onChangeView(3, '产品一览视图-供应商', key.key)} key="supplier" icon={<OrderedListOutlined />} title={<span style={{ padding: '0 1rem' }}>产品一览视图-供应商</span>}>
        {
          state.suppliers.map(x => {
            return <Menu.Item key={x.id}><span style={{ padding: '0 1rem' }}>{x.name}</span></Menu.Item>;
          })
        }
      </Menu.SubMenu>
      {/* { optionView && <Menu.Divider />}
      <Menu.Item key="2" icon={<PlusOutlined />}>
        <span style={{ padding: '0 1rem' }}>自定义视图</span>
      </Menu.Item> */}
    </Menu>
  );

  const optionMenu = [
    <div>
      {(authorities.find(x => x === 'delete_goods') || currentUser.category_id === 1) && <Button onClick={showDeleteConfirm} type="danger" icon={<DeleteOutlined />}>
        <span style={{ padding: '0 1rem' }}>删除产品</span>
      </Button>}
    </div>
  ];
  const onSearch = (keyword) => {
    setPage(1, state.pagination.limit);
    if ((keyword || '').trim().length === 0) setKeyword(undefined);
    else setKeyword(keyword);
  }

  const views = [
    [
      { label: '产品号前缀', width: '120px', item: 'prefix', align: 'center' },
      {
        label: '产品名称(中文)', width: '200px', item: 'name_cn', sortable: 'true',
        render: (text, row, index) => {
          return <div><Button style={{ padding: 0 }} onClick={() => onClickId(index)} size='small' type='link'>{text}</Button></div>
        }
      },
      { label: '产品名称(英文)', width: '460px', item: 'name_en', sortable: 'true' },
      { label: '报关品名', width: '180px', item: 'category_id', align: 'center' },

      {
        label: '产品数量', width: '140px', item: 'goods_spec_count', align: 'center', render: (text, row, index) => {
          return <Button style={{ padding: 0 }} type="link" onClick={() => onClickSpec(index)} size="small">{text || text > 0 ? text : '添加产品号'}</Button>
        }
      },
      { label: '备注', width: '260px', item: 'remark' }
    ],
    [
      { label: '产品号', width: '150px', item: 'goods_spec_name', align: 'center' },
      { label: '尺寸', width: '160px', item: 'size' },
      { label: '重量', width: '90px', item: 'weight', align: 'right' },
      { label: '产品号前缀', width: '110px', item: 'prefix', align: 'center' },
      { label: '产品名称(英文)', width: '460px', item: 'goods_name_en' },
      { label: '产品名称(中文)', width: '230px', item: 'goods_name_cn' },
      { label: '报关品名', width: '160px', item: 'category_name' },
    ],
    [
      { label: '产品号', width: '150px', item: 'goods_spec_name', align: 'center' },
      { label: '尺寸', width: '160px', item: 'size' },
      { label: '重量', width: '80px', item: 'weight', align: 'right' },
      { label: '产品名称(英文)', width: '460px', item: 'goods_name_en' },
      { label: '客户名称', width: '240px', item: 'buyer_name' },
      { label: '件数/每箱', width: '90px', align: 'right', item: 'pcs_per_carton' },
      { label: '箱数/每托', width: '90px', align: 'right', item: 'carton_count_per_pallet' },
      { label: '当前价格', width: '90px', align: 'right', item: 'price' },
    ],
    [
      { label: '产品号', width: '150px', item: 'goods_spec_name', align: 'center' },
      { label: '尺寸', width: '160px', item: 'size' },
      { label: '重量', width: '80px', item: 'weight', align: 'right' },
      { label: '产品名称(英文)', width: '460px', item: 'goods_name_en' },
      { label: '供应商名称', width: '240px', item: 'supplier_name' },
      { label: '当前价格', width: '230px', item: 'price' },
    ]
  ];
  return (
    <div style={{ padding: '0.5rem 1.5rem 10rem 1.5rem' }}  >
      <Table
        showView={true}
        optionView={optionView}
        currentView={view.name}
        showFilter={true}
        onSearch={onSearch}
        onSearchPlaceHolder="请输入产品中文或者英文名称"
        setSelectedCallback={setSelected}
        setPageCallback={setPage}
        isLoadding={isLoadding}
        expandable={false}
        hasCheckbox={true}
        optionMenu={optionMenu}
        title="产品管理"
        newLabel="新建产品"
        showNewLabel={authorities.find(x => x === 'create_goods') || currentUser.category_id === 1}
        newOptionMenu={newOptionMenu}
        showFooter={true}
        rows={view_rows}
        total_rows={total_rows}
        onNew={() => setShowNew(!isShowNew)}
        relation={
          {
            category_id: { data: goods_category, field: 'name' },
          }
        }
        header={views[view.type]}
        bordered={true} />
      <Page
        width="720px"
        title="新建产品"
        onCloseCallback={() => setShowNew(!isShowNew)}
        afterClose={afterClose}
        body={<GoodsNew mode="new" onSaveCallback={onNewCallback} onCloseCallback={() => setShowNew(!isShowNew)} />}
        visible={isShowNew} />
      <Page
        width="720px"
        title="产品详细"
        onCloseCallback={() => setShowEdit(!isShowEdit)}
        afterClose={afterClose}
        body={<GoodsNew mode="edit" onSaveCallback={onSaveCallback} goods={clickedIndex !== undefined ? rows[clickedIndex] : []} onCloseCallback={() => setShowEdit(!isShowEdit)} />}
        visible={isShowEdit}
      />
      <Page
        width="1024px"
        title={`产品号列表 [${ clickedIndex !== undefined ? (rows[clickedIndex] || {}).name_en : ''} - ${clickedIndex !== undefined ? (rows[clickedIndex] || {}).name_cn : ''}]`}
        onCloseCallback={() => setShowSpec(false)}
        afterClose={afterClose}
        body={<SpecList goods={clickedIndex !== undefined ? (rows[clickedIndex] || {}) : {}} onCloseCallback={() => setShowSpec(false)} />}
        visible={isShowSpec}
      />
      <Page
        title={`产品批量导入`}
        isMaximize={true}
        body={<GoodsImport
          goodsCategory={goods_category}
          insertGoods={insert}
          updateGoods={update}
          reload={reload}
          insertGoodsSpec={insertSpecs}
          updateGoodsSpec={updateSpecs}
          onCloseCallback={() => setShowImport(false)}
        />}
        onCloseCallback={() => setShowImport(false)}
        visible={isShowImport}
      />
      <Page
        title={`产品通栏表导入更新`}
        isMaximize={true}
        body={<GoodsImportAll
          buyers={buyers}
          suppliers={suppliers}
          reload={reload}
          onCloseCallback={() => setShowImportAll(false)}
        />}
        onCloseCallback={() => setShowImportAll(false)}
        visible={isShowImportAll}
      />
    </div>
  );
});
